import React, { Component, useEffect } from 'react';
import Loader from '../../../utils/Loader';
import ScheduleCallCard from './scheduleCallCard';
import SubmitTaskCard from './submitTaskCard';
import CallHistory from './callHistory/callHistory';
import CancelFeedback from '../../common/cancelFeedback';
import { connect } from 'react-redux';
import ConfirmName from '../../common/confirmName';
import { setShowConfirmName } from '../../../redux/utilities/utils.actions';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import { useForm } from 'react-hook-form';
import Coachform from './coachForm';


class CoachCourse extends Component {


	constructor(props) {
		super(props);
		Loader.hide();
	}

	componentWillUnmount() {
		localStorage.removeItem('courseQueryParams');
	}
	componentDidMount() {
		const script = document.createElement('script');
		script.src = 'https://assets.calendly.com/assets/external/widget.js';
		script.async = true;
		document.body.appendChild(script);
	}

	render() {
		const {
			coachDetails,
			coachDetails: { total_calls, completed_calls, show_feedback, feedback_url, role_name },
			displayText,
			courseExpMsg,
			setShowConfirmName,
			showCancelPopup,
			course_id,
		} = this.props;

		let coachMsg = ""
		let coachTitle = "STEP COACH Calls and Tasks"
		let coachT1 = ""
		if (completed_calls == 0 && role_name == "" && course_id == "487") {
			coachTitle = "Welcome to Coach Unlimited!"
			coachT1 = "You are now a part of a <strong>HIGHLY PERSONALISED</strong> English course that will be <strong>UNIQUELY DESIGNED</strong> for your needs."
			coachMsg = "Please answer the following three questions to help us build out the right course for your needs. Happy Learning!"
		}

		let coachMessage = localStorage.getItem("coachMessageTemp");
		let coachTempMessage = ""
		if (coachMessage == 1) {
			coachTempMessage = "Thanks for answering these questions! Your Coach Unlimited course has been successfully created for your specific needs. The course syllabus has been sent to your email/SMS/WhatsApp. If you have any questions, you can reply to the email or text us on WhatsApp, and we will get back to you! You can now book your first Coach call!";
			localStorage.removeItem('coachMessageTemp');
		}

		return (
			<div className="coachContainer">
				<link
					href="https://assets.calendly.com/assets/external/widget.css"
					rel="stylesheet"
				/>

				<span
					className="alert alert-success"
					id="infoScheduleSuccess"
					style={{ display: !!displayText ? 'block' : 'none' }}
					dangerouslySetInnerHTML={{ __html: displayText }}
				/>

				{show_feedback && !!total_calls && completed_calls >= 5 ? (
					<div className="alert alert-success">
						Your feedback is valuable to us. Please share your experience with this
						course <a style= {{ textDecoration: 'underline' }} href={`${feedback_url}`} target="_blank" rel="noopener noreferrer">here</a>.
					</div>
				) : null}

				<div
					className=""
					style={{ display: !!coachMsg ? 'block' : 'none' }}
					dangerouslySetInnerHTML={{ __html: coachMsg }}
				/>

				<div
					className="alert alert-success"
					style={{ display: !!coachTempMessage ? 'block' : 'none' }}
					dangerouslySetInnerHTML={{ __html: coachTempMessage }}
				/>

				{!!coachMsg && <Coachform/>}
				<div
					className="alert alert-danger"
					id="infoScheduleFail"
					style={{ display: !!courseExpMsg ? 'block' : 'none' }}
					dangerouslySetInnerHTML={{ __html: courseExpMsg }}
				/>
				{!coachMsg ? (
				<Card>
					<Card.Body>
						<Row>
							{coachDetails !== undefined &&
							!coachDetails.is_b2b_user &&
							!(!!total_calls && completed_calls >= total_calls) ? (
								<ScheduleCallCard />
							) : null}

							{!!total_calls && completed_calls >= total_calls && (
								<div className="alert alert-success">
									Click
									<span
										className="divAsAnchor"
										onClick={() => {
											setShowConfirmName(true);
										}}
									>
										here
									</span>
									to generate your course completion certificate
								</div>
							)}

							{!!coachDetails &&
								Object.keys(coachDetails).length > 0 &&
								!!coachDetails.show_tasks && <SubmitTaskCard />}
						</Row>
					</Card.Body>
				</Card>
				): null }
				{!coachMsg ? (
				<CallHistory />
				): null }
				
				<ConfirmName />
				{showCancelPopup && <CancelFeedback />}
			</div>
			
		);
	}
}

const mapStateToProps = (state) => {
	const {
		coachDetails,
		displayText,
		courseExpMsg,
		showCancelPopup,
		course_id,
	} = state.rootReducer.myCourse;
	return {
		coachDetails,
		course_id,
		displayText,
		courseExpMsg,
		showCancelPopup,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowConfirmName: (val) => dispatch(setShowConfirmName(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CoachCourse);